import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'sent-status-icon',
  template: `
    <i class='sent-status-icon'
      [class.success]='success'
      [class.error]='!success'>
    </i>`,
  styleUrls: ['sent-status-icon.component.scss'],
})
export class SentStatusIconComponent {
  @Input() success: boolean = false;
}
